<i *ngIf="isFunctionForMobile(text)" class="fas fa-check color-green padding-left-20" aria-hidden="true"></i>
<i *ngIf="!isFunctionForMobile(text)" class="fas fa-times padding-left-20" aria-hidden="true"></i>